<template>
  <div class="image-lightbox">
    <div v-show="show" class="wrapper">
      <div class="header p-4 absolute w-full flex items-center justify-center">
        <div class="close absolute" @click="$emit('close')">
          <ArrowIcon />
        </div>
        <div class="name">{{ currentImg.name }}</div>
      </div>
      <div class="gallery-swiper">
        <div class="swiper-wrapper">
          <div
            v-for="img in imgs"
            :key="img.id"
            class="swiper-slide"
            :style="{ backgroundImage: `url('${img.src}')` }"
          ></div>
        </div>
      </div>
      <div class="footer absolute w-full" />
    </div>
  </div>
</template>
<script>
import ArrowIcon from '@/components/common/svg/ArrowLeft.vue';
import Swiper from 'swiper';
import 'swiper/swiper.min.css';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    imgs: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: '',
    },
  },
  components: { ArrowIcon },
  computed: {
    currentImg() {
      return this.imgs.find(img => img.id === this.currentId) || {};
    },
  },
  mounted() {
    this.initSwiper();
  },
  watch: {
    show(newVal) {
      if (!newVal) return;

      if (!this.$swiper) {
        this.initSwiper();
      } else {
        this.$swiper.update();
      }
      this.$swiper.slideTo(this.imgs.findIndex(img => img.id === this.currentId));
    },
  },
  methods: {
    initSwiper() {
      this.$swiper = new Swiper('.gallery-swiper', {
        initialSlide: this.imgs.findIndex(img => img.id === this.currentId),
        on: {
          activeIndexChange: () => {
            if (!this.$swiper) return;

            this.$emit('update:currentId', this.imgs[this.$swiper.activeIndex].id);
          },
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$header-height: 62px;
$footer-height: 48px;

.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  z-index: 1;

  .header {
    top: 0;
    left: 0;
    height: $header-height;

    .close {
      top: 16px;
      left: 16px;
      transform: translateY(50%);
    }

    .name {
      font-family: Poppins;
      font-size: 16px;
      font-weight: 700;
    }
  }

  .gallery-swiper {
    height: calc(100% - #{$header-height} - #{$footer-height});
    background-color: #000;
    margin-top: $header-height;

    .swiper-slide {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .footer {
    height: $footer-height;
    bottom: 0;
    left: 0;
  }
}
</style>
